import { lazyLoad } from 'utils/loadable';

export const DealerSegmentSettingsComponent = lazyLoad(
  () => import('./index'),
  module => module.DealerSegmentSettingsComponent,
);
